import * as React from 'react';

const IconDelete = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
    <title>icon-close</title>
    <g
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 16L2 2l14 14zM2 16L16 2 2 16z" />
    </g>
  </svg>
);

export default IconDelete;
